import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";

@CwtModel({ name: 'money-origin' })
@CwtCrudContract({ path: 'money-origin' })
export class MoneyOrigin extends CwtApiEntity {
    @CwtProp() name: string;
}